import constants from '../constants';

const isShadesEqual = (shade1, shade2) => Math.abs(shade1 - shade2) < constants.COMMON.ACCURACY;

export default isShadesEqual;
